/*
 *
 * OperationActionsModal
 *
 * @version 1.0.0
 * @author Davide Campus
 * @since 31-Oct-2024
 */

import React from 'react'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  capture: <PortalMessage id='t.app.operationsmanagement.popup.title.capture' defaultMessage='Capture' />,
  refund: <PortalMessage id='t.app.operationsmanagement.popup.title.refund' defaultMessage='Refund' />,
  void: <PortalMessage id='t.app.operationsmanagement.popup.title.void' defaultMessage='Void' />,
  cancel: <PortalMessage id='t.app.operationsmanagement.popup.title.cancel' defaultMessage='Cancel' />,
  cancel_refund: <PortalMessage id='t.app.orders.operation.popup.title.cancelRefund' defaultMessage='Cancel Refund' />,
  incremental: <PortalMessage id='t.app.operationsmanagement.popup.title.incremental' defaultMessage='Incremental' />,
  capturedAmount: <PortalMessage id='t.app.orders.operation.popup.capturedAmount' defaultMessage='Captured amount' />,
  refundAmount: <PortalMessage id='t.app.orders.operation.popup.refundAmount' defaultMessage='Refund amount' />,
  voidedAmount: <PortalMessage id='t.app.orders.operation.popup.voidedAmount' defaultMessage='Voided amount' />,
  cancelAmount: <PortalMessage id='t.app.orders.operation.popup.cancelAmount' defaultMessage='Cancel amount' />,
  incrementalAmount: (
    <PortalMessage id='t.app.orders.operation.popup.incrementalAmount' defaultMessage='Incremental amount' />
  ),
  validNumber: (
    <PortalMessage id='t.app.orders.operation.popup.error.validNumber' defaultMessage='Enter a valid number' />
  ),
  close: <PortalMessage id='t.app.project.btn.close' defaultMessage='Close' />,
  confirm: <PortalMessage id='t.app.project.btn.confirm' defaultMessage='Confirm' />,
  captionDisclaimer: (
    <PortalMessage
      id='t.app.orders.operation.popup.captionDisclaimer'
      defaultMessage='Capture of other amounts will no longer be available when confirming'
    />
  )
}

export default formattedMessage

export const messages = {
  closeAriaLabel: {
    id: 't.app.accessibility.project.btn.close.ariaLabel',
    defaultMessage: 'Close'
  },
  capture: {
    id: 't.app.operationsmanagement.popup.title.capture',
    defaultMessage: 'Capture'
  },
  refund: {
    id: 't.app.operationsmanagement.popup.title.refund',
    defaultMessage: 'Refund'
  },
  void: {
    id: 't.app.operationsmanagement.popup.title.void',
    defaultMessage: 'Void'
  },
  cancel: {
    id: 't.app.operationsmanagement.popup.title.cancel',
    defaultMessage: 'Cancel'
  },
  cancel_refund: {
    id: 't.app.orders.operation.popup.title.cancelRefund',
    defaultMessage: 'Cancel Refund'
  },
  incremental: {
    id: 't.app.operationsmanagement.popup.title.incremental',
    defaultMessage: 'Incremental'
  },
  capturedAmount: {
    id: 't.app.orders.operation.popup.capturedAmount',
    defaultMessage: 'Captured amount'
  },
  refundAmount: {
    id: 't.app.orders.operation.popup.refundAmount',
    defaultMessage: 'Refund amount'
  },
  voidedAmount: {
    id: 't.app.orders.operation.popup.voidedAmount',
    defaultMessage: 'Voided amount'
  },
  cancelAmount: {
    id: 't.app.orders.operation.popup.cancelAmount',
    defaultMessage: 'Cancel amount'
  },
  incrementalAmount: {
    id: 't.app.orders.operation.popup.incrementalAmount',
    defaultMessage: 'Incremental amount'
  },
  captionDisclaimer: {
    id: 't.app.orders.operation.popup.captionDisclaimer',
    defaultMessage: 'Capture of other amounts will no longer be available when confirming'
  },
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  }
}
